<template>
  <div style="transform: none;">
    <el-input
      :placeholder="placeholder"
      :value="value"
      @input="onChange($event)"
    />
  </div>
</template>

<script>
export default {
  name: "RestrictedCharacterInput",
  props: {
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    onChangeInput: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
    pattern: {
      type: String,
      default: "DEFAULT_PATTERN",
    },
  },
  data () {
    return {
      isActive: false,
    };
  },
  created () {},
  methods: {
    onChange ($event) {
      let replacedText = "";
      switch (this.pattern) {
        case "IHAI_INPUT_PATTERN":
          replacedText = $event.replace(
            // eslint-disable-next-line no-useless-escape
            /[！-／：-＠’＾｀“”〜￥＜＞？＋＊「」｛｝［］＿｜−!-/:-@\[\]\\\^\`\"'()¥|_~]+/g,
            ""
          );
          break;
      }
      this.$emit("onChangeInput", replacedText);
    },
    onClickDraw () {
      this.isActive = true;
    },
    onSelect ($event) {
      this.$emit("onSubmit", $event);
    },
  },
  mounted () {},
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.el-dialog__body {
  padding: 0 20px !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import url("../../node_modules/myscript/dist/myscript.min.css");

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: $turquoise-base;
}
</style>
